import { render, staticRenderFns } from "./homepage-featured-charts.vue?vue&type=template&id=3d71c9bb&scoped=true"
import script from "./homepage-featured-charts.vue?vue&type=script&setup=true&lang=js"
export * from "./homepage-featured-charts.vue?vue&type=script&setup=true&lang=js"
import style0 from "./homepage-featured-charts.vue?vue&type=style&index=0&id=3d71c9bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d71c9bb",
  null
  
)

export default component.exports